import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import ParentDashboard from "@/pages/ParentDashboard";
import TutorDashboard from "@/pages/TutorDashboard";
import StudentDashboard from "@/pages/StudentDashboard";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import ResetPassword from "@/pages/ResetPassword";
import Legal from "@/pages/Legal";
import ContactUs from "@/pages/ContactUs";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Auth />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/legal/:doc" element={<Legal />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/dashboard/parent" element={<ProtectedRoute roles={["parent", "admin"]}><ParentDashboard /></ProtectedRoute>} />
            <Route path="/dashboard/tutor" element={<ProtectedRoute roles={["tutor", "admin"]}><TutorDashboard /></ProtectedRoute>} />
            <Route path="/dashboard/student" element={<ProtectedRoute roles={["student"]}><StudentDashboard /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
